import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Login } from './Login';
import { LoadingSpinner } from '../../components/LoadingSpinner';

const navItems = [
  {
    to: '/admin', label: 'Dashboard', end: true,
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="5.5" height="5.5" rx="1" /><rect x="10.5" y="2" width="5.5" height="5.5" rx="1" />
        <rect x="2" y="10.5" width="5.5" height="5.5" rx="1" /><rect x="10.5" y="10.5" width="5.5" height="5.5" rx="1" />
      </svg>
    ),
  },
  {
    to: '/admin/coffees', label: 'Coffees',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 7h10v5a4 4 0 01-4 4H6a4 4 0 01-4-4V7z" /><path d="M12 8h1.5a2.5 2.5 0 010 5H12" /><path d="M4 2v3M7 2v3M10 2v3" />
      </svg>
    ),
  },
  {
    to: '/admin/orders', label: 'Orders',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 4l2-2h10l2 2" /><rect x="2" y="4" width="14" height="12" rx="1" /><path d="M6 8a3 3 0 006 0" />
      </svg>
    ),
  },
  {
    to: '/admin/inquiries', label: 'Inquiries',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3h12v9H6l-3 3V3z" /><path d="M7 7h4M7 10h2" />
      </svg>
    ),
  },
  {
    to: '/admin/invoices', label: 'Invoices',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 2h7l4 4v10a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z" /><path d="M11 2v4h4" /><path d="M6 9h6M6 12h4" />
      </svg>
    ),
  },
  {
    to: '/admin/buyers', label: 'Buyers', section: 'CRM',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="6" r="3" /><path d="M3 16v-1a4 4 0 014-4h4a4 4 0 014 4v1" />
      </svg>
    ),
  },
  {
    to: '/admin/contracts', label: 'Contracts',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="2" width="12" height="14" rx="1" /><path d="M7 6h4M7 9h4M7 12h2" />
      </svg>
    ),
  },
  {
    to: '/admin/offers', label: 'Offers',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 9l4-6h6l4 6-4 6H6l-4-6z" /><path d="M6 9h6" />
      </svg>
    ),
  },
  {
    to: '/admin/change-requests', label: 'Change Requests',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 2a7 7 0 100 14 7 7 0 000-14z" /><path d="M9 6v3.5l2.5 1.5" />
      </svg>
    ),
  },
  {
    to: '/admin/export-invoices', label: 'Export Invoices',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 10v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4" /><path d="M9 3v8M6 6l3-3 3 3" />
      </svg>
    ),
  },
  {
    to: '/admin/packing-lists', label: 'Packing Lists',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 2L3 5v8l6 3 6-3V5L9 2z" /><path d="M3 5l6 3 6-3M9 8v7" />
      </svg>
    ),
  },
  {
    to: '/admin/production', label: 'Overview', section: 'Production', end: true,
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l6-7 6 7v7a1 1 0 01-1 1H4a1 1 0 01-1-1z" /><path d="M7 17v-5h4v5" />
      </svg>
    ),
  },
  {
    to: '/admin/production/deliveries', label: 'Cherry Deliveries',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="6.5" cy="6.5" r="2" /><circle cx="11.5" cy="6.5" r="2" /><path d="M9 4.5v4M4 13.5c0-2 1.5-3.5 5-3.5s5 1.5 5 3.5" />
      </svg>
    ),
  },
  {
    to: '/admin/production/batches', label: 'Batches',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="14" height="10" rx="1" /><path d="M5 5V4a2 2 0 014 0v1M9 5V4a2 2 0 014 0v1" /><path d="M6 10h6M6 13h4" />
      </svg>
    ),
  },
  {
    to: '/admin/production/trips', label: 'Trips',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="5" cy="14" r="2" /><circle cx="13" cy="14" r="2" /><path d="M3 14H2V6l3-4h7l3 4v4" /><path d="M7 14h4" /><path d="M11 6H5" />
      </svg>
    ),
  },
  {
    to: '/admin/production/drying', label: 'Drying Beds',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 13h14M2 10h14M4 10V7a5 5 0 0110 0v3" /><path d="M7 10V8M11 10V8" />
      </svg>
    ),
  },
  {
    to: '/admin/production/farmers', label: 'Farmers',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 2C6 2 3 5 3 9c0 2 .8 3.5 2 4.5" /><path d="M9 2c3 0 6 3 6 7 0 2-.8 3.5-2 4.5" /><path d="M5 16h8" /><path d="M9 2v14" />
      </svg>
    ),
  },
  {
    to: '/admin/production/centres', label: 'Collection Centres',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 2l2 4h4l-3 3 1 4-4-2-4 2 1-4-3-3h4z" />
      </svg>
    ),
  },
  {
    to: '/admin/production/users', label: 'Prod Users',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="7" cy="6" r="3" /><path d="M1 16v-1a5 5 0 0110 0v1" /><path d="M14 8v5M16.5 10.5h-5" />
      </svg>
    ),
  },
  {
    to: '/admin/production/inventory', label: 'Inventory',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 5l7-3 7 3v8l-7 3-7-3V5z" /><path d="M9 2v14M2 5l7 3 7-3" />
      </svg>
    ),
  },
  {
    to: '/admin/production/reports', label: 'Prod Reports',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 14V8M8 14V4M12 14v-6M16 14v-3" />
      </svg>
    ),
  },
];

export const AdminLayout: React.FC = () => {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  if (isLoading) {
    return (
      <div className="admin-shell min-h-screen flex items-center justify-center bg-[#F5F3F0]">
        <LoadingSpinner size="md" />
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;

  const handleLogout = async () => {
    await logout();
    navigate('/admin');
  };

  return (
    <div className="admin-shell min-h-screen bg-[#F5F3F0] flex">
      {/* Sidebar */}
      <aside className={`${collapsed ? 'w-[68px]' : 'w-60'} bg-[#111111] flex flex-col transition-all duration-300 ease-in-out`}>
        {/* Header */}
        <div className={`flex items-center ${collapsed ? 'justify-center px-3' : 'justify-between px-5'} h-16 border-b border-white/[0.08]`}>
          {!collapsed && (
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#F05A1E] to-[#D44A14] flex items-center justify-center">
                <span className="text-white text-xs font-bold">L20</span>
              </div>
              <div>
                <p className="text-[13px] font-semibold text-white leading-none">Lot 20</p>
                <p className="text-[10px] text-white/40 uppercase tracking-[0.15em] mt-0.5">Admin</p>
              </div>
            </div>
          )}
          <button
            onClick={() => setCollapsed(!collapsed)}
            className="p-1.5 text-white/30 hover:text-white/60 rounded-md hover:bg-white/[0.06] transition-colors"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              {collapsed
                ? <><path d="M3 4h10M3 8h10M3 12h10" /></>
                : <><path d="M3 4h10M3 8h6M3 12h10" /></>
              }
            </svg>
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
          {navItems.map((item) => (
            <React.Fragment key={item.to}>
              {item.section && !collapsed && (
                <p className="text-[10px] text-white/25 uppercase tracking-[0.2em] font-medium px-3 pt-5 pb-2">
                  {item.section}
                </p>
              )}
              {item.section && collapsed && <div className="my-3 mx-3 border-t border-white/[0.06]" />}
              <NavLink
                to={item.to}
                end={item.end}
                title={collapsed ? item.label : undefined}
                className={({ isActive }) =>
                  `flex items-center gap-3 ${collapsed ? 'justify-center px-0' : 'px-3'} py-2.5 rounded-lg text-[13px] font-medium transition-all duration-150 ${
                    isActive
                      ? 'bg-white/[0.1] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]'
                      : 'text-white/50 hover:text-white/80 hover:bg-white/[0.05]'
                  }`
                }
              >
                <span className="flex-shrink-0">{item.icon}</span>
                {!collapsed && <span>{item.label}</span>}
              </NavLink>
            </React.Fragment>
          ))}
        </nav>

        {/* Footer */}
        <div className="px-3 py-4 border-t border-white/[0.08] space-y-0.5">
          <button
            onClick={handleLogout}
            className={`w-full flex items-center gap-3 ${collapsed ? 'justify-center px-0' : 'px-3'} py-2.5 text-[13px] text-white/40 hover:text-white/70 hover:bg-white/[0.05] rounded-lg transition-colors`}
            title={collapsed ? 'Sign out' : undefined}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
              <path d="M6 16H4a1 1 0 01-1-1V3a1 1 0 011-1h2" /><path d="M12 12l3-3-3-3" /><path d="M15 9H7" />
            </svg>
            {!collapsed && <span>Sign out</span>}
          </button>
          <a
            href="/"
            className={`w-full flex items-center gap-3 ${collapsed ? 'justify-center px-0' : 'px-3'} py-2.5 text-[13px] text-white/40 hover:text-white/70 hover:bg-white/[0.05] rounded-lg transition-colors`}
            title={collapsed ? 'View site' : undefined}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
              <path d="M15 9.5V15a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h5.5" /><path d="M11 2h5v5" /><path d="M8 10l8-8" />
            </svg>
            {!collapsed && <span>View site</span>}
          </a>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-8 overflow-auto">
        <div className="max-w-[1400px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
